module.exports = __webpack_public_path__ + "img/homeDetails.ab3665b2.png";